/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex';

import {
	GETTER_WISHLIST,
	ACTION_REMOVE_FROM_WISHLIST
} from './store/wishlist/wishlist';

import ProductCard from './components/ProductCard.vue';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("wishlist");

let resizeChange = null;

const productsLimit = {
	mobile: 4,
	desktop: 9
};

const breakpoints = {
	mobile: 1199
};

const selectors = {
	popupContainer: "[data-wishlist-popup]"
}

const __vue_script__ = {
	name: 'Wishlist',
	data: () => ({
		windowWidth: window.innerWidth,
		productsToShow: window.innerWidth > breakpoints.mobile ? productsLimit.desktop : productsLimit.mobile,
		isInlineProductCard: null
	}),
	created() {
		this.isInlineProductCard = !(window.location.href.indexOf("wishlist") > -1);
	},
	mounted() {
		window.addEventListener("resize", () => {
			clearTimeout(resizeChange);

			resizeChange = setTimeout(() => {
				this.windowWidth = window.innerWidth;
			}, 50);
		});
	},
	computed: {
		...mapGetters([
			GETTER_WISHLIST
		])
	},
	methods: {
		...mapActions([
			ACTION_REMOVE_FROM_WISHLIST
		]),
		getWishlistedVariant(product) {
			const wishlisted_variant_id = product?.wishlisted_variant_id;

			if (!wishlisted_variant_id || !product.hasOwnProperty('variants')) {
				return this.first_available_variant;
			}

			const wishlisted_variant = product?.variants.find(variant => variant.id === wishlisted_variant_id);

			if (!wishlisted_variant) {
				return this.first_available_variant;
			}

			return wishlisted_variant;
		},
		loadMoreProducts() {
			this.productsToShow += window.innerWidth > breakpoints.mobile ? productsLimit.desktop : productsLimit.mobile;
		},

	},
	components: {
		ProductCard
	}
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wishlist", attrs: { id: "wishlist" } }, [
    !_vm.wishlist.length
      ? _c("div", { staticClass: "wishlist__empty" }, [
          _c("p", { staticClass: "wishlist__empty-message" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm._f("t")("general.wishlist.empty")) +
                "\n\t\t"
            ),
          ]),
        ])
      : _c("div", [
          _vm.isInlineProductCard
            ? _c("h3", [_vm._v(_vm._s(_vm._f("t")("general.wishlist.label")))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid-row grid-row-2 grid-row-height-auto" },
            _vm._l(_vm.productsToShow, function (index) {
              return index <= _vm.wishlist.length
                ? _c("div", { key: index, staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "minicart__product" },
                      [
                        _c("ProductCard", {
                          attrs: {
                            product: _vm.wishlist[index - 1],
                            "current-variant": _vm.getWishlistedVariant(
                              _vm.wishlist[index - 1]
                            ),
                            "inline-style": _vm.isInlineProductCard,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]),
    _vm._v(" "),
    _vm.productsToShow < _vm.wishlist.length ||
    _vm.wishlist.length > _vm.productsToShow
      ? _c("div", { staticClass: "wishlist__load-more" }, [
          _c(
            "button",
            {
              staticClass: "button button--primary wishlist__load-more-button",
              attrs: { type: "button" },
              on: { click: _vm.loadMoreProducts },
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm._f("t")("general.wishlist.load_more")) +
                  "\n\t\t"
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "assets-extend/js/vue/Wishlist.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__